var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.showCompany ? _c('company-selection', {
    attrs: {
      "filter": _vm.CompanyServiceEnum.TOWING
    },
    model: {
      value: _vm.company,
      callback: function callback($$v) {
        _vm.company = $$v;
      },
      expression: "company"
    }
  }) : _vm._e(), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    attrs: {
      "label": _vm.$t('objects.towing.companyId'),
      "outlined": "",
      "rules": _vm.required
    },
    model: {
      value: _vm.value.companyId,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "companyId", $$v);
      },
      expression: "value.companyId"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.towing.externalId'),
      "hint": _vm.$t('objects.towing.externalIdHint'),
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.value.externalId,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "externalId", $$v);
      },
      expression: "value.externalId"
    }
  }), _c('v-textarea', {
    attrs: {
      "label": _vm.$t('objects.towing.notes'),
      "outlined": ""
    },
    model: {
      value: _vm.value.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "notes", $$v);
      },
      expression: "value.notes"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "datetime-local",
      "label": _vm.$t('objects.towing.pickupDate'),
      "outlined": ""
    },
    model: {
      value: _vm.value.pickupDateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "pickupDateFormable", $$v);
      },
      expression: "value.pickupDateFormable"
    }
  }), _c('v-subheader', [_vm._v(_vm._s(_vm.$t("objects.towing.pickup")))]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.street'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.pickupLocation.street,
      callback: function callback($$v) {
        _vm.$set(_vm.value.pickupLocation, "street", $$v);
      },
      expression: "value.pickupLocation.street"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.zip'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.pickupLocation.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.value.pickupLocation, "zip", $$v);
      },
      expression: "value.pickupLocation.zip"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.city'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.pickupLocation.city,
      callback: function callback($$v) {
        _vm.$set(_vm.value.pickupLocation, "city", $$v);
      },
      expression: "value.pickupLocation.city"
    }
  })], 1), _vm.value.pickupLocation.geo ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('geo-finder-field', {
    attrs: {
      "type": "lat",
      "value": _vm.value.pickupLocation.geo.lat,
      "address": _vm.value.pickupLocation,
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.accidentDetails.lat') + ' *',
      "data-test-geo-lat": ""
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.value.pickupLocation.geo, "lat", $event);
      },
      "update:address": function updateAddress($event) {
        return _vm.$set(_vm.value, "pickupLocation", $event);
      }
    }
  })], 1) : _vm._e(), _vm.value.pickupLocation.geo ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('geo-finder-field', {
    attrs: {
      "type": "lng",
      "value": _vm.value.pickupLocation.geo.lng,
      "address": _vm.value.pickupLocation,
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.accidentDetails.lng') + ' *',
      "data-test-geo-lng": ""
    },
    on: {
      "update:value": function updateValue($event) {
        return _vm.$set(_vm.value.pickupLocation.geo, "lng", $event);
      },
      "update:address": function updateAddress($event) {
        return _vm.$set(_vm.value, "pickupLocation", $event);
      }
    }
  })], 1) : _vm._e()], 1), _c('v-subheader', [_vm._v(_vm._s(_vm.$t("objects.towing.delivery")))]), _c('v-row', [_c('v-col', [_vm.company ? _c('v-btn', {
    attrs: {
      "small": "",
      "elevation": "0"
    },
    on: {
      "click": _vm.toTowingCompany
    }
  }, [_vm._v("Zum Abschleppdienst")]) : _vm._e(), _vm.destination ? _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "small": "",
      "elevation": "0"
    },
    on: {
      "click": _vm.toWorkshopCompany
    }
  }, [_vm._v("Zur Werkstatt")]) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.company.companyName'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.deliveryLocation.line2,
      callback: function callback($$v) {
        _vm.$set(_vm.value.deliveryLocation, "line2", $$v);
      },
      expression: "value.deliveryLocation.line2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.street'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.deliveryLocation.street,
      callback: function callback($$v) {
        _vm.$set(_vm.value.deliveryLocation, "street", $$v);
      },
      expression: "value.deliveryLocation.street"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.zip'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.deliveryLocation.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.value.deliveryLocation, "zip", $$v);
      },
      expression: "value.deliveryLocation.zip"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.address.city'),
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.deliveryLocation.city,
      callback: function callback($$v) {
        _vm.$set(_vm.value.deliveryLocation, "city", $$v);
      },
      expression: "value.deliveryLocation.city"
    }
  })], 1)], 1), _c('v-subheader', [_vm._v(_vm._s(_vm.$t("objects.towing.other")))]), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.towing.url'),
      "hint": _vm.$t('objects.towing.urlHint'),
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.value.url,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "url", $$v);
      },
      expression: "value.url"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.$t('objects.towing.cost'),
      "outlined": ""
    },
    model: {
      value: _vm.value.cost,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "cost", _vm._n($$v));
      },
      expression: "value.cost"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }